/** Saved API criteria may carry one value, a list, or no value for null checks. */
export const filterValues = (value: unknown): Array<string | number> =>
   (Array.isArray(value) ? value : value == null ? [] : [value]).filter(
      (v): v is string | number =>
         typeof v === 'string' || typeof v === 'number'
   )

export const isNullFilter = (operator: string) =>
   operator === 'IS NULL' || operator === 'IS NOT NULL'

/** Null checks are complete criteria even though they have no selected values. */
export const hasFilterValue = (filter: { operator: string; value?: unknown }) =>
   isNullFilter(filter.operator) || filterValues(filter.value).length > 0
